import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/img/common/chevron_left.svg'
import _imports_1 from '@/img/common/chevron_right.svg'


const _hoisted_1 = { class: "monthNavigator" }
const _hoisted_2 = { class: "left" }
const _hoisted_3 = { class: "center" }
const _hoisted_4 = { class: "right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-hollow",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.prevMonth && _ctx.prevMonth(...args)))
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("img", { src: _imports_0 }, null, -1)
      ]))
    ]),
    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$filters.date(_ctx.localValue, 'MMMM YYYY')), 1),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-hollow",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.nextMonth && _ctx.nextMonth(...args)))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("img", { src: _imports_1 }, null, -1)
      ]))
    ])
  ]))
}